// @generated by protoc-gen-es v1.7.2
// @generated from file proctoring/v1/recording.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3, Struct } from "@bufbuild/protobuf";
import { Session_Key } from "./session_pb.js";

/**
 * @generated from enum proctoring.v1.RecordingType
 */
export const RecordingType = proto3.makeEnum(
  "proctoring.v1.RecordingType",
  [
    {no: 0, name: "RECORDING_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RECORDING_TYPE_WEBCAM", localName: "WEBCAM"},
    {no: 2, name: "RECORDING_TYPE_SCREENCAPTURE", localName: "SCREENCAPTURE"},
  ],
);

/**
 * @generated from enum proctoring.v1.RecordingStatus
 */
export const RecordingStatus = proto3.makeEnum(
  "proctoring.v1.RecordingStatus",
  [
    {no: 0, name: "RECORDING_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RECORDING_STATUS_RECORDING", localName: "RECORDING"},
    {no: 2, name: "RECORDING_STATUS_PROCESSING", localName: "PROCESSING"},
    {no: 3, name: "RECORDING_STATUS_AVAILABLE", localName: "AVAILABLE"},
    {no: 4, name: "RECORDING_STATUS_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from message proctoring.v1.RecordingKey
 */
export const RecordingKey = proto3.makeMessageType(
  "proctoring.v1.RecordingKey",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(RecordingType) },
    { no: 3, name: "number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingBlobInfo
 */
export const RecordingBlobInfo = proto3.makeMessageType(
  "proctoring.v1.RecordingBlobInfo",
  () => [
    { no: 1, name: "key", kind: "message", T: RecordingKey },
    { no: 4, name: "number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message proctoring.v1.MediaInfo
 */
export const MediaInfo = proto3.makeMessageType(
  "proctoring.v1.MediaInfo",
  () => [
    { no: 1, name: "json", kind: "message", T: Struct },
    { no: 2, name: "container", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duration", kind: "message", T: Duration },
    { no: 4, name: "video_codec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "audio_codec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "overall_bitrate", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingInfo
 */
export const RecordingInfo = proto3.makeMessageType(
  "proctoring.v1.RecordingInfo",
  () => [
    { no: 1, name: "key", kind: "message", T: RecordingKey },
    { no: 2, name: "media_info", kind: "message", T: MediaInfo },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(RecordingStatus) },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceStartRequest
 */
export const RecordingServiceStartRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceStartRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(RecordingType) },
    { no: 3, name: "process_continuously", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceStartResponse
 */
export const RecordingServiceStartResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceStartResponse",
  () => [
    { no: 1, name: "recording_key", kind: "message", T: RecordingKey },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceGetBlobUploadUrlRequest
 */
export const RecordingServiceGetBlobUploadUrlRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceGetBlobUploadUrlRequest",
  () => [
    { no: 1, name: "recording_blob_info", kind: "message", T: RecordingBlobInfo },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceGetBlobUploadUrlResponse
 */
export const RecordingServiceGetBlobUploadUrlResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceGetBlobUploadUrlResponse",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceUncheckedGetBlobUploadUrlRequest
 */
export const RecordingServiceUncheckedGetBlobUploadUrlRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceUncheckedGetBlobUploadUrlRequest",
  () => [
    { no: 1, name: "recording_blob_info", kind: "message", T: RecordingBlobInfo },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceUncheckedGetBlobUploadUrlResponse
 */
export const RecordingServiceUncheckedGetBlobUploadUrlResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceUncheckedGetBlobUploadUrlResponse",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceAckRequest
 */
export const RecordingServiceAckRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceAckRequest",
  () => [
    { no: 1, name: "recording_blob_info", kind: "message", T: RecordingBlobInfo },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceAckResponse
 */
export const RecordingServiceAckResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceAckResponse",
  [],
);

/**
 * @generated from message proctoring.v1.RecordingServiceConcatRequest
 */
export const RecordingServiceConcatRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceConcatRequest",
  () => [
    { no: 1, name: "recording_key", kind: "message", T: RecordingKey },
    { no: 2, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceEndRequest
 */
export const RecordingServiceEndRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceEndRequest",
  () => [
    { no: 1, name: "recording_key", kind: "message", T: RecordingKey },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceEndResponse
 */
export const RecordingServiceEndResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceEndResponse",
  [],
);

/**
 * @generated from message proctoring.v1.RecordingServiceConcatResponse
 */
export const RecordingServiceConcatResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceConcatResponse",
  [],
);

/**
 * @generated from message proctoring.v1.RecordingServiceAttachMediaInfoRequest
 */
export const RecordingServiceAttachMediaInfoRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceAttachMediaInfoRequest",
  () => [
    { no: 1, name: "recording_key", kind: "message", T: RecordingKey },
    { no: 2, name: "media_info", kind: "message", T: MediaInfo },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceAttachMediaInfoResponse
 */
export const RecordingServiceAttachMediaInfoResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceAttachMediaInfoResponse",
  [],
);

/**
 * @generated from message proctoring.v1.RecordingServiceListRequest
 */
export const RecordingServiceListRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceListRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceListResponse
 */
export const RecordingServiceListResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceListResponse",
  () => [
    { no: 1, name: "recording_keys", kind: "message", T: RecordingKey, repeated: true },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceGetRequest
 */
export const RecordingServiceGetRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceGetRequest",
  () => [
    { no: 1, name: "recording_key", kind: "message", T: RecordingKey },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceGetResponse
 */
export const RecordingServiceGetResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceGetResponse",
  () => [
    { no: 1, name: "recording_info", kind: "message", T: RecordingInfo },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceGetAllRequest
 */
export const RecordingServiceGetAllRequest = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceGetAllRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.RecordingServiceGetAllResponse
 */
export const RecordingServiceGetAllResponse = proto3.makeMessageType(
  "proctoring.v1.RecordingServiceGetAllResponse",
  () => [
    { no: 1, name: "recording_info", kind: "message", T: RecordingInfo },
  ],
);

